
import React, { Component } from 'react';
import Picker, { SKIN_TONE_NEUTRAL } from 'emoji-picker-react';
import { Row, Col, Button } from 'react-bootstrap';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Emojis extends Component {

    constructor(props) {
        super(props);

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount() {

        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(e) {
        if (this.props.showEmojis && this.wrapperRef && !this.wrapperRef.current.contains(e.target) && !this.props.invoker.current.contains(e.target)) {
            this.props.handleEmojisClick();
        }
    }
    render() {
        return (
            <div ref={this.wrapperRef} className='position-absolute start-0 emojis'>
                <Row>
                    <Col lg={12}>
                        <Button size='sm' variant='light' onClick={this.props.handleEmojisClick} className='float-end' style={{ padding: "5px 10px" }}><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </Col>
                </Row>
                <Picker
                    onEmojiClick={this.props.emojiClick}
                    disableAutoFocus={true}
                    skinTone={SKIN_TONE_NEUTRAL}
                    groupNames={{
                        smileys_people: 'yellow faces',
                        animals_nature: 'cute dogs and also trees',
                        food_drink: 'milkshakes and more',
                        travel_places: 'I love trains',
                        activities: 'lets play a game',
                        objects: 'stuff',
                        symbols: 'more stuff',
                        flags: 'fun with flags',
                        recently_used: 'did I really use those?!'
                    }}
                    native
                />

            </div>);
    }
}

export default Emojis;